import * as React from "react";
import { Tooltip } from "@fluentui/react-components";
import PropTypes from "prop-types";

export const FluentTooltip = ({ target, text, positioning = "above-start", ...rest }) => (
  <Tooltip content={text} relationship="label" positioning={positioning} {...rest}>
    {target}
  </Tooltip>
);

FluentTooltip.propTypes = {
  text: PropTypes.string,
  target: PropTypes.any,
  positioning: PropTypes.string,
};
